<template>
  <div>

    <md-list class="md-double-line">
      <md-list-item
        v-for="(article, index) in getReversedArticles"
        :key="index">
        <div class="md-list-text-container">
          <span>
            <a :href="article.url" target="_blank">{{ article.title }}</a>
          </span>
          <span
            v-if="article.genre === 'SetDance'"
            class="md-primary type-of-event"
            key="articleSetDance">セットダンス</span>
          <span
            v-else-if="article.genre === 'SeanNos'"
            class="md-accent type-of-event"
            key="articleSeanNos">シャンノース</span>
          <span
            v-else-if="article.genre === 'CeiliDance'"
            class="md-accent type-of-event"
            key="articleSeanNos">ケーリーダンス</span>
          <span
            v-else-if="article.genre === 'OldStyleStepDance'"
            class="md-accent type-of-event"
            key="articleSeanNos">オールドスタイル</span>
          <span
            v-else-if="article.genre === 'ModernStyleStepDance'"
            class="md-accent type-of-event"
            key="articleSeanNos">モダンスタイル</span>
          <span
            v-else-if="article.genre === 'Others'"
            class="md-primary type-of-event"
            key="articleOthers">その他</span>
          <p>
            {{ article.description }} by {{ article.writers }}
          </p>
        </div>
        <md-divider></md-divider>
      </md-list-item>
    </md-list>

  </div>
</template>

<script>
import db from '../db'
import { getIdFromURL } from 'vue-youtube-embed'

export default {
  name: 'articleList',
  data () {
    return {
      articles: {}
    }
  },
  firebase: {
    articles: db.ref('/articles').orderByChild('timestamp')
  },
  computed: {
    getReversedArticles () {
      return this.articles.reverse()
    }
  },
  created () {
  },
  methods: {
    getEventSchedule: function (startTime, endTime) {
      let zeroFill = require('zero-fill')
      startTime = new Date(startTime)
      endTime = new Date(endTime)
      return startTime.getFullYear() + '年' + (startTime.getMonth() + 1) + '月' + startTime.getDate() + '日(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ') ' + new Date(startTime).getHours() + ':' + zeroFill(2, new Date(startTime).getMinutes()) + '-' + new Date(endTime).getHours() + ':' + zeroFill(2, new Date(endTime).getMinutes())
    },
    getHoursAndMinutes: function (dateTime) {
      let zeroFill = require('zero-fill')
      return new Date(dateTime).getHours() + ':' + zeroFill(2, new Date(dateTime).getMinutes())
    },
    getThumbnail: function (url) {
      return 'https://i.ytimg.com/vi/' + getIdFromURL(url) + '/mqdefault.jpg'
    },
    getDescription: function (set) {
      let orders = []
      let rythmns = []
      let description = ''
      for (let i = 0; i < set.figures.length; i++) {
        // variation のあるフィガーのリズムを重複して表示しないようにする
        if (orders.indexOf(set.figures[i].order) < 0) {
          description += i !== 0 ? ' - ' + set.figures[i].rythmn : set.figures[i].rythmn
          orders.push(set.figures[i].order)
          rythmns.push(set.figures[i].rythmn)
        }
      }

      // すべてのフィガーが同じリズムのとき
      if (Array.from(new Set(rythmns)).length === 1) {
        return 'All ' + Array.from(new Set(rythmns))[0] + 's'
      }

      return description
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  /*display: inline-block;*/
  margin: 0 10px;
}

.jpCaption {
  font-size: 12px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// AllArticles.vue?7c84b6ff